import { Box, IconButton, Stack, Typography } from '@dtx-company/design-system/src'
import { Collapse } from '@mui/material'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'
import { useBuyPlanPageContext } from '../../context/useBuyPlanPageContext'
import { useId, useState } from 'react'

function PlanDetail({
  detail
}: {
  detail: { label?: string; description?: string; description_heap_key?: string }
}): JSX.Element {
  const [collapse, setCollapse] = useState(false)
  const labelId = useId()
  const descriptionId = useId()
  return (
    <>
      <Stack component="dt" direction={'row'} spacing={1} sx={{ alignItems: 'center' }}>
        <IconButton
          size="small"
          onClick={() => {
            setCollapse(!collapse)
            fireAnalyticsEvent('BuyPlanPage_PlanDetailDescription_Toggled', {
              key: detail.description_heap_key,
              open: !collapse
            })
          }}
          variant={'text'}
          icon={collapse ? ExpandLess : ExpandMore}
          aria-expanded={collapse ? 'true' : 'false'}
          aria-describedby={collapse ? descriptionId : labelId}
          data-testid={`buyplanpage-${detail.description_heap_key}`}
        />
        <Typography variant="bodyMedium" color="primary.light" id={labelId}>
          {detail.label}
        </Typography>
      </Stack>
      <Collapse component="dd" in={collapse}>
        <Box
          sx={theme => ({
            color: theme.palette.onSurface.secondary
          })}
        >
          <Typography variant="bodySmall" color="onSurface.secondary" id={descriptionId}>
            {detail.description}
          </Typography>
        </Box>
      </Collapse>
    </>
  )
}

export function BuyPlanPagePlanDetails(): JSX.Element {
  const { document } = useBuyPlanPageContext()
  const { data } = document

  return (
    <>
      <Typography variant="subtitleSmall">{data.plan_details_label}</Typography>
      <Box component="dl" sx={theme => ({ color: theme.palette.onSurface.secondary })}>
        {data.plan_details?.map((detail, index) => {
          return <PlanDetail key={index} detail={detail} />
        })}
      </Box>
    </>
  )
}
